import { render, staticRenderFns } from "./reserve_cg.vue?vue&type=template&id=7b82b873&scoped=true"
import script from "./reserve_cg.vue?vue&type=script&lang=js"
export * from "./reserve_cg.vue?vue&type=script&lang=js"
import style0 from "./reserve_cg.vue?vue&type=style&index=0&id=7b82b873&prod&scoped=true&lang=css"
import style1 from "./reserve_cg.vue?vue&type=style&index=1&id=7b82b873&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b82b873",
  null
  
)

export default component.exports